<template lang="pug">
  .module__main
    .module__title Список контроллеров
    .module-content__container.table-scroll
      .handler-group__container(v-for="handler in handlers" :key="`handler-group-${handler.handler}`")
        .handler-group__title {{ handler.handler }}
        .handler-group-info__container
          .handler-group-info__data
            .handler-group-info__title Общий баланс:
            .handler-group-data__val {{ handler.total_balance }}
        .table__container.handler-accounts__table
          .table-list__container
            el-table(
              v-loading="isLoading"
              :data="handler.accounts"
              style="width: 100%; font-size: 12px"
            )
              el-table-column(prop="name" label="Аккаунт" width="200")
                template(slot-scope="scope")
                  .handler-account-name__container(:class="scope.row.active ? 'color-success' : 'color-danger'")
                    i.el-icon-check(v-if="scope.row.active" title="АКТИВЕН")
                    i.el-icon-close(v-else title="НЕ АКТИВЕН")
                    span.handler-account-name {{ scope.row.name }}
              el-table-column(prop="description" label="Описание" width="200")
              el-table-column(prop="balance" label="Баланс" width="150")
              el-table-column(prop="wallet" label="Кошелек вывода" width="350")
                template(slot-scope="scope")
                  .val(v-if="scope.row.wallet")
                    span.handler-wallet {{ scope.row.wallet }}
                    i.el-icon-copy-document.copy__btn(@click="copyTextToClipboard(scope.row.wallet)")
              el-table-column(prop="min_amount" label="Мин. сумма" width="120")
              el-table-column(prop="withdraw_amount" label="Сумма вывода" width="120")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_HANDLERS_INFO } from "@/store/const/handlers";
import instruments from "@/mixins/instruments";

export default {
  name: 'Handlers',
  mixins: [
    instruments,
  ],
  data() {
    return {
      intervalHandle: null,
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('handlers', [
      'handlers',
    ]),
    isLoading() {
      return this.loading(LOAD_HANDLERS_INFO) === 'loading';
    },
    groupedHandlers() {
      const result = {};
      for (const handler of this.handlers)  {
        if (!result[handler.group]) {
          result[handler.group] = { name: handler.group, total_balance: 0, handlers: [] };
        }
        result[handler.group].total_balance = this.floatPlus(result[handler.group].total_balance, handler.balance);
        result[handler.group].handlers.push(handler);
      }
      for (const handler of this.handlers)  {
        result[handler.group].handlers = result[handler.group].handlers.sort((a, b) => a.priority - b.priority);
      }

      return result;
    }
  },
  async mounted() {
    await this.loadHandlersInfo();
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  methods: {
    ...mapActions('handlers', {
      loadHandlersInfo: LOAD_HANDLERS_INFO,
    }),
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadHandlersInfo(), 10000);
    },
  }
};
</script>
<style>
.handler-group__container {
    padding: 8px;
    border: 1px solid #afafaf;
    background-color: #efefef;
    margin-bottom: 5px;
}

.handler-group__title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}


.handler-accounts__table {
    margin-top: 10px;
}

.handler-group-info__data {
    display: flex;
    padding: 8px;
    border: 1px solid #afafaf;
    background-color: #f7f7f7;
    border-radius: 4px;
    width: fit-content;
}

.handler-group-info__title {
    font-weight: bold;
    margin-right: 5px;
}

.handler-wallet {
    font-family: monospace;
}

.copy__btn {
    cursor: pointer;
}

.copy__btn:hover {
    color: #6b6969;
}

.handler-account-name__container {
    font-size: 14px;
}

.handler-account-name {
    margin-left: 5px;
}

</style>
